import { Alert, Link } from '@mui/material';
import { PAST_DUE_NOTE, SUPPORT_LINK } from '../content';

/** Overdue subscriptions are never cancelled here, so the customer is told. */
export default function PastDueNotice({ onSupport }: { onSupport: () => void }) {
  return (
    <Alert severity="warning">
      {PAST_DUE_NOTE}{' '}
      <Link component="button" type="button" variant="body2" onClick={onSupport} sx={{ verticalAlign: 'baseline' }}>
        {SUPPORT_LINK}
      </Link>
    </Alert>
  );
}
